import React from 'react';
import { Icon } from 'antd';
import BaseBlock from '../BaseBlock';
import { modalNames } from '../../../../config';
import { useLinkClickHandler } from '../../../../hooks/useLinkClickHandler';
import styles from './index.module.scss';

const initialData = {
  phone: '',
  dopPhone: '',
  text: '',
  editMode: false,
};

const PhoneLinkBlock = () => {
  const handleClick = useLinkClickHandler({
    initialData,
    modalName: modalNames.phone,
  });

  return (
    <BaseBlock
      tooltipTitle="Добавить номер телефона"
      onClick={handleClick}
    >
      <Icon
        className={styles.icon}
        type="phone"
      />
    </BaseBlock>
  );
};

export default PhoneLinkBlock;
